export default __webpack_public_path__ + "static/media/EhsanSayaAbout.5fa349a2.png";